import React, { Suspense, lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import NyafazPortalFlowLayout from "./NyafazPortalFlowLayout";
import Login, { RequirePortalAuth } from "./pages/Login";
import { LegacyOrgDetailRedirect, renderNaturalsControlRoutes } from "./naturals-control/NaturalsControlRoutes";

const Organizations = lazy(() => import("./pages/Organizations"));
const PortalHome = lazy(() => import("./pages/PortalHome"));
const ProductRoutes = lazy(() => import("./pages/products/ProductRoutes"));
const CreateOrganization = lazy(() => import("./pages/CreateOrganization"));
const EscalatedComplaints = lazy(() => import("./pages/EscalatedComplaints"));
const Analytics = lazy(() => import("./pages/Analytics"));
const ReleaseNotes = lazy(() => import("./pages/ReleaseNotes"));

const Fallback = () => (
  <div className="min-h-[40vh] flex items-center justify-center theme-body">Loading…</div>
);

export function renderNaturalsPortalRoutes({ portalHome = false } = {}) {
  return (
    <Route element={<NyafazPortalFlowLayout />}>
      {portalHome ? <Route path="/" element={<Navigate to="/naturals-portal" replace />} /> : null}
      <Route path="/naturals-portal" element={<Login />} />
      <Route
        path="/naturals-portal/home"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <PortalHome />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/naturals-portal/organizations"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <Organizations />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/naturals-portal/products/:productSlug/*"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <ProductRoutes />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/naturals-portal/analytics/*"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <Analytics />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/naturals-portal/organizations/new"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <CreateOrganization />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/naturals-portal/organizations/:orgId"
        element={
          <RequirePortalAuth>
            <LegacyOrgDetailRedirect />
          </RequirePortalAuth>
        }
      />
      <Route
        path="/naturals-portal/organizations/:orgId/edit"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <CreateOrganization />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      {renderNaturalsControlRoutes()}
      <Route
        path="/naturals-portal/escalated-complaints"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <EscalatedComplaints />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/naturals-portal/release-notes"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <ReleaseNotes />
            </Suspense>
          </RequirePortalAuth>
        }
      />
    </Route>
  );
}
